// Region metadata + unique SEO editorial content per region.
// Each entry powers the /regiones/:slug page (long-tail SEO).

export const REGIONS = [
    {
        slug: "arica-y-parinacota",
        name: "Arica y Parinacota",
        shortName: "Arica y Parinacota",
        capital: "Arica",
        population: "252.000 habitantes aprox.",
        mainCities: ["Arica", "Putre"],
        intro: "La región de Arica y Parinacota enfrenta una realidad particular en materia de adicciones por su condición de frontera con Perú y Bolivia, lo que la expone al tráfico transfronterizo de sustancias. La oferta de centros de rehabilitación de drogas en la región es acotada pero especializada, con equipos que combinan abordaje clínico y pertinencia cultural indígena-andina.",
        context: "La región requiere programas sensibles a la cultura aymara y a contextos de migración reciente. Los centros ambulatorios y residenciales en Arica suelen trabajar en coordinación con SENDA Previene municipal.",
    },
    {
        slug: "tarapaca",
        name: "Tarapacá",
        shortName: "Tarapacá",
        capital: "Iquique",
        population: "382.000 habitantes aprox.",
        mainCities: ["Iquique", "Alto Hospicio", "Pozo Almonte"],
        intro: "Tarapacá, con Iquique como núcleo urbano, presenta tasas de consumo problemático de cocaína y pasta base superiores al promedio nacional según reportes de SENDA. Los centros de rehabilitación de drogas de la región se concentran en Iquique y Alto Hospicio, con modalidades residencial y ambulatoria intensiva.",
        context: "Por el dinamismo económico minero y portuario, existen convenios entre centros privados y empresas para atender trabajadores con consumo problemático. El tratamiento dual con trastornos del sueño y ansiedad es frecuente.",
    },
    {
        slug: "antofagasta",
        name: "Antofagasta",
        shortName: "Antofagasta",
        capital: "Antofagasta",
        population: "680.000 habitantes aprox.",
        mainCities: ["Antofagasta", "Calama", "Tocopilla", "Mejillones"],
        intro: "Antofagasta es la región con mayor consumo problemático de cocaína en Chile según sucesivas encuestas SENDA. Su oferta de centros de rehabilitación de drogas es una de las más desarrolladas del norte, con comunidades terapéuticas residenciales en Antofagasta ciudad y Calama, además de programas ambulatorios corporativos asociados a la industria minera.",
        context: "Los perfiles frecuentes incluyen trabajadores mineros, jóvenes universitarios y policonsumo de cocaína con alcohol. Los centros suelen ofrecer horarios flexibles compatibles con turnos mineros.",
    },
    {
        slug: "atacama",
        name: "Atacama",
        shortName: "Atacama",
        capital: "Copiapó",
        population: "286.000 habitantes aprox.",
        mainCities: ["Copiapó", "Vallenar", "Caldera", "Chañaral"],
        intro: "La región de Atacama ha visto crecer las alertas por consumo de pasta base y cocaína en sectores urbanos de Copiapó y Vallenar. La red de centros de rehabilitación de drogas combina dispositivos públicos financiados por SENDA con centros privados de capacidad media.",
        context: "La distancia entre localidades exige planes de seguimiento post-alta con fuerte componente telemático. Programas familiares son clave dada la estructura comunitaria rural de la zona.",
    },
    {
        slug: "coquimbo",
        name: "Coquimbo",
        shortName: "Coquimbo",
        capital: "La Serena",
        population: "820.000 habitantes aprox.",
        mainCities: ["La Serena", "Coquimbo", "Ovalle", "Illapel"],
        intro: "La región de Coquimbo concentra su oferta de centros de rehabilitación de drogas en el eje La Serena-Coquimbo, con varias comunidades terapéuticas residenciales ubicadas en entornos rurales cercanos. Su clima seco y la baja contaminación la hacen un destino apreciado por pacientes de otras regiones que buscan un entorno terapéutico tranquilo.",
        context: "El perfil de consumo mezcla alcohol, marihuana y cocaína. En Ovalle y la zona cordillerana existen programas ambulatorios comunitarios con pertinencia rural.",
    },
    {
        slug: "valparaiso",
        name: "Valparaíso",
        shortName: "Valparaíso",
        capital: "Valparaíso",
        population: "1.960.000 habitantes aprox.",
        mainCities: ["Valparaíso", "Viña del Mar", "Quilpué", "Villa Alemana", "San Antonio", "Quillota", "Los Andes"],
        intro: "La región de Valparaíso es la segunda con mayor oferta de centros de rehabilitación de drogas en Chile, después de la Metropolitana. Concentra comunidades terapéuticas residenciales de alta calidad en zonas como Olmué, Limache y el interior de la V región, además de programas ambulatorios y online en Viña del Mar y Valparaíso.",
        context: "El consumo problemático presenta patrones mixtos: alcohol en adultos, marihuana y cocaína en jóvenes, y una creciente demanda por tratamientos online debido a la vida universitaria y profesional activa.",
    },
    {
        slug: "metropolitana",
        name: "Metropolitana",
        shortName: "Región Metropolitana",
        capital: "Santiago",
        population: "8.420.000 habitantes aprox.",
        mainCities: ["Santiago", "Providencia", "Las Condes", "Ñuñoa", "La Florida", "Maipú", "Puente Alto", "San Bernardo", "Colina"],
        intro: "La Región Metropolitana concentra la mayor oferta de centros de rehabilitación de drogas del país: comunidades terapéuticas residenciales, programas ambulatorios intensivos, clínicas psiquiátricas con unidades de desintoxicación y plataformas 100% online. Santiago reúne equipos profesionales de primer nivel, con psiquiatras especialistas en adicciones, psicólogos clínicos y programas duales para trastornos psiquiátricos asociados.",
        context: "El alto volumen permite elegir por modalidad, precio y enfoque clínico. Existen centros especializados para adolescentes, mujeres, profesionales y adultos mayores, con convenios con isapres y seguros complementarios.",
    },
    {
        slug: "ohiggins",
        name: "O'Higgins",
        shortName: "O'Higgins",
        capital: "Rancagua",
        population: "990.000 habitantes aprox.",
        mainCities: ["Rancagua", "Machalí", "San Fernando", "Rengo", "Santa Cruz"],
        intro: "La región de O'Higgins cuenta con comunidades terapéuticas residenciales reconocidas, varias de ellas ubicadas en sectores rurales cercanos a Rancagua y Machalí. Su proximidad a Santiago permite atender tanto a pacientes locales como a quienes buscan alejarse de la capital para un tratamiento residencial prolongado.",
        context: "El consumo problemático se concentra en zonas urbanas y en trabajadores temporeros agrícolas. La oferta incluye planes accesibles financiados por SENDA y centros privados de nivel medio-alto.",
    },
    {
        slug: "maule",
        name: "Maule",
        shortName: "Maule",
        capital: "Talca",
        population: "1.110.000 habitantes aprox.",
        mainCities: ["Talca", "Curicó", "Linares", "Cauquenes", "Constitución"],
        intro: "La región del Maule ha visto crecer en los últimos años el consumo problemático de alcohol y marihuana, especialmente en población adolescente y adulta joven. Los centros de rehabilitación de drogas del Maule se distribuyen entre Talca, Curicó y Linares, con foco en comunidades terapéuticas residenciales de mediana capacidad.",
        context: "El contexto rural y agrícola favorece intervenciones comunitarias y participación familiar prolongada. Varios centros aplican enfoques integrativos con arteterapia, trabajo en huerta y actividad física estructurada.",
    },
    {
        slug: "nuble",
        name: "Ñuble",
        shortName: "Ñuble",
        capital: "Chillán",
        population: "511.000 habitantes aprox.",
        mainCities: ["Chillán", "Chillán Viejo", "San Carlos", "Bulnes"],
        intro: "Ñuble, creada como región en 2018, cuenta con una red en expansión de centros de rehabilitación de drogas, principalmente en Chillán. La oferta combina centros privados con dispositivos ambulatorios SENDA, y una demanda creciente por tratamientos online desde localidades rurales.",
        context: "El consumo de alcohol histórico y el creciente policonsumo juvenil son las principales demandas. Se promueve el enfoque biopsicosocial con trabajo familiar intensivo.",
    },
    {
        slug: "biobio",
        name: "Biobío",
        shortName: "Biobío",
        capital: "Concepción",
        population: "1.660.000 habitantes aprox.",
        mainCities: ["Concepción", "Talcahuano", "Chiguayante", "San Pedro de la Paz", "Los Ángeles", "Coronel"],
        intro: "La región del Biobío es la tercera con mayor oferta de centros de rehabilitación de drogas en Chile. Concepción y el Gran Concepción concentran comunidades terapéuticas residenciales, clínicas con unidades de desintoxicación y programas ambulatorios intensivos. Los Ángeles aporta centros orientados a población rural y forestal.",
        context: "El perfil universitario de Concepción se refleja en una alta demanda por tratamientos ambulatorios y online para jóvenes profesionales. Programas con enfoque de género (mujeres y diversidades) han crecido en los últimos años.",
    },
    {
        slug: "araucania",
        name: "Araucanía",
        shortName: "La Araucanía",
        capital: "Temuco",
        population: "1.010.000 habitantes aprox.",
        mainCities: ["Temuco", "Padre Las Casas", "Villarrica", "Pucón", "Angol"],
        intro: "La Araucanía cuenta con centros de rehabilitación de drogas distribuidos principalmente entre Temuco, Villarrica y Pucón, varios de ellos en entornos naturales que favorecen la recuperación. La región requiere programas con pertinencia intercultural, especialmente para pacientes mapuche que representan un porcentaje relevante de la población.",
        context: "La oferta incluye comunidades terapéuticas con trabajo espiritual indígena, programas rurales y centros con enfoque familiar extendido. El tratamiento del consumo de alcohol es el de mayor demanda.",
    },
    {
        slug: "los-rios",
        name: "Los Ríos",
        shortName: "Los Ríos",
        capital: "Valdivia",
        population: "404.000 habitantes aprox.",
        mainCities: ["Valdivia", "La Unión", "Panguipulli", "Río Bueno"],
        intro: "La región de Los Ríos tiene su núcleo de centros de rehabilitación de drogas en Valdivia, ciudad universitaria que concentra equipos clínicos especializados. El entorno natural, con ríos y bosques, ha favorecido el surgimiento de comunidades terapéuticas en modalidad residencial rural.",
        context: "El consumo problemático se asocia históricamente al alcohol, con creciente demanda por atención a consumo de marihuana y drogas sintéticas en población joven. Programas online han crecido significativamente.",
    },
    {
        slug: "los-lagos",
        name: "Los Lagos",
        shortName: "Los Lagos",
        capital: "Puerto Montt",
        population: "890.000 habitantes aprox.",
        mainCities: ["Puerto Montt", "Osorno", "Castro", "Puerto Varas", "Ancud"],
        intro: "Los Lagos cuenta con una red creciente de centros de rehabilitación de drogas entre Puerto Montt, Osorno y la Isla de Chiloé. La geografía dispersa de la región ha impulsado fuertemente los tratamientos online, que hoy son una alternativa real para quienes viven en zonas rurales o insulares.",
        context: "El consumo de alcohol con patrón binge es muy frecuente, junto a demandas específicas de tratamiento en trabajadores salmoneros. Programas en Chiloé integran pertinencia cultural y trabajo comunitario.",
    },
    {
        slug: "aysen",
        name: "Aysén",
        shortName: "Aysén",
        capital: "Coyhaique",
        population: "104.000 habitantes aprox.",
        mainCities: ["Coyhaique", "Puerto Aysén", "Chile Chico"],
        intro: "Aysén, la región más despoblada de Chile, enfrenta el desafío de la distancia para acceder a tratamientos de rehabilitación de drogas. Coyhaique concentra la oferta residencial disponible, y los tratamientos online se han consolidado como la principal vía de acceso para quienes viven en localidades pequeñas.",
        context: "El aislamiento geográfico y el clima extremo influyen en el consumo de alcohol y en la demanda por acompañamiento telemático continuo. Derivaciones a Puerto Montt o Santiago son frecuentes en casos complejos.",
    },
    {
        slug: "magallanes",
        name: "Magallanes",
        shortName: "Magallanes",
        capital: "Punta Arenas",
        population: "166.000 habitantes aprox.",
        mainCities: ["Punta Arenas", "Puerto Natales", "Porvenir"],
        intro: "Magallanes es la región más austral de Chile y cuenta con una oferta acotada de centros de rehabilitación de drogas, concentrada en Punta Arenas. Tratamientos online y derivaciones a regiones del norte son parte habitual de la red de atención.",
        context: "El consumo de alcohol con alto impacto clínico es el principal motivo de consulta. Los programas comunitarios trabajan junto a SENDA Magallanes y la red pública de salud.",
    },
];

export function getRegionBySlug(slug) {
    return REGIONS.find((r) => r.slug === slug) || null;
}

export function getRegionByName(name) {
    return REGIONS.find((r) => r.name === name) || null;
}
